import React, { useContext } from "react";
import { useAnimateInView } from "./useAnimateInView";
import SHA256 from "crypto-js/sha256";
import BackgroundImage from "../Assets/AccomplishmentsPage/bg.png";
import MedalImage from "../Assets/AccomplishmentsPage/best.svg";
import { AppPreferencesContext } from "../../General/AppPreferencesProvider";
import { AppPreferencesContextType } from "../../types/AppPreferencesProvider";
import AIStar from "../Assets/Common/ai-star.svg";

// S3 arn: (dev) arn:aws:s3:::seem-eoy-2024/logos/
const logoURL = "https://seem-eoy-2024.s3.eu-central-1.amazonaws.com/logos/";

interface AccomplishmentsPageProps {
  data?: {
    customer_name: string;
    title: string;
    description: string;
  };
}

const AccomplishmentsPage: React.FC<AccomplishmentsPageProps> = ({ data }) => {
  const { ref, animateClassNames } = useAnimateInView();
  const {
    appPreferences: { useAI },
  } = useContext(AppPreferencesContext) as AppPreferencesContextType;

  return (
    <div
      className={`eoy-page accomplishments-page ${animateClassNames}`}
      ref={ref}
    >
      <img src={BackgroundImage} alt="Accomplishments" className="bg-image" />
      <h2 className="page-title">Accomplishments 2025 </h2>
      <div className={`accomplishments-container ${useAI ? "use-ai" : ""}`}>
        {useAI && <img src={AIStar} alt="AI" className="ai-star" />}
        <h4 className="accomplishments-title">{data?.title}</h4>
        <p className="accomplishments-description">{data?.description}</p>
        <div className="accomplishments-logo-container">
          <img
            src={`${logoURL}${SHA256(data?.customer_name ?? "").toString()}.svg`}
            alt="Accomplishments"
            className="logo-image"
          />
          <img src={MedalImage} alt="Medal" className="medal-image" />
        </div>
        {useAI && <div className="ai-text">Generated by Seemplicity AI</div>}
      </div>
    </div>
  );
};

export default AccomplishmentsPage;
